module.exports = __webpack_public_path__ + "static/media/logo-lacmeg.5f7a0bdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-lacmeg.png
// module id = 431
// module chunks = 0